module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "hero",
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "epigraph"
    }
  }), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_vm._v("A hero ventures forth from the world of common day into a region of supernatural wonder: fabulous forces are there encountered and a decisive victory is won: the hero comes back from this mysterious adventure with the power to bestow boons on his fellow man.")])]), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('blockquote', [_c('p', {
    staticClass: "ind"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEPH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMPBELL,")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("The Hero with a Thousand Faces")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39d23704","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/5-start.vue
// module id = 84
// module chunks = 0